import { useEffect } from "react";

/**
 * Fixed-position toast that auto-dismisses. Kept dependency-free and styled
 * with the app's design tokens rather than the old module's inline styles.
 */
export function Toast({ tone = "success", children, onDone, duration = 3500 }) {
  useEffect(() => {
    if (!onDone) return;
    const t = setTimeout(onDone, duration);
    return () => clearTimeout(t);
  }, [onDone, duration]);

  const bg =
    tone === "error"
      ? "var(--color-error)"
      : tone === "sent-back"
      ? "var(--status-submitted-fg)"
      : "var(--color-success)";

  return (
    <div
      className="fixed top-6 left-1/2 -translate-x-1/2 z-[500] flex items-center gap-2 px-5 py-3 rounded-xl text-sm font-semibold text-white shadow-[0_10px_30px_-8px_rgba(0,0,0,0.35)] whitespace-nowrap"
      style={{ background: bg }}
    >
      {children}
    </div>
  );
}
